<template>

  <div
    class="meet-main adapted-video-meet-width"
    :class="fullscreen ? 'fullscreen' : null">
    <div class="meet-main-iframe">
      <VideoEmbed
        :roomId="meetMainToken"
        :userName="me.name"
        :showLeaveButton="false" />
    </div>
    <div class="meet-main-actions bg-dark">
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': fullscreen }"
       @click="fullscreen=true">
       <i class="fa-solid fa-expand"></i> Expandir
      </button>
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': !fullscreen }"
       @click="fullscreen=false">
       <i class="fa-solid fa-table-columns"></i> Dividir
      </button>
      <button
       class="btn btn-danger"
       @click="close()">
       <i class="fa-solid fa-phone"></i>
      </button>
    </div>
  </div>

</template>

<script>
import VideoEmbed from './VideoEmbed.vue'
export default {
  name: 'MeetMain',
  components: {
    VideoEmbed
  },
  data () {
    return {
      fullscreen: false
    }
  },
  computed: {
    meetMainToken () {
      return this.$store.getters.getMeetMain.token
    },
    meetMainViewport () {
      return this.$store.getters.getMeetMain.viewport
    },
    me () {
      return this.$store.getters.getMe
    }
  },
  mounted () {
  },
  methods: {
    changeViewport (value) {
      this.$store.dispatch('updateMeetMain', { viewport: value })
    },
    close () {
      this.$router.push({ query: { ...this.$route.query, meet_token: undefined } }) // remove meet_token
      this.$store.dispatch('unsetMeetMain', {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.meet-main {
  position: absolute;
  z-index: 99999;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
  .meet-main > .meet-main-iframe {
    flex: 1;
  }
  .meet-main > .meet-main-actions {
    padding: 10px;
    text-align: center;
  }
.meet-main.fullscreen {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Meet/MeetMain.vue